// eventTracker.js
import posthog from "posthog-js";

// Wrapper function to track events
const trackEvent = (event: string, properties = {}) => {
  // Function to determine the users platform
  const getPlatform = () => {
    const { userAgent } = navigator;
    if (userAgent.match(/Android/i)) return "mobile";
    if (userAgent.match(/iPhone|iPad|iPod/i)) return "mobile";
    if (window.matchMedia("(display-mode: standalone)").matches) return "pwa";
    return "web";
  };

  // Determine the platform here (web, mobile, or PWA)
  const platform = getPlatform();

  // Add the platform property to the properties object
  const propertiesWithPlatform = {
    ...properties,
    platform,
  };

  // Call the PostHog capture method
  posthog.capture(event, propertiesWithPlatform);
};

export default trackEvent;
